import React from "react";
import { View, StyleSheet, TextStyle } from "react-native";
import NoTransactions from "@assets/svg/Wallet/NoTransactions";
import Text from "@components/CustomText";
import color from "@constants/color";

interface NoTransactionsViewProps {
  text?: string;
}

const NoTransactionsView: React.FC<NoTransactionsViewProps> = ({
  text = "No Transactions",
}) => {
  return (
    <View style={styles.container}>
      <NoTransactions />
      <Text variant="title_18_semi" style={styles.text}>
        {text}
      </Text>
    </View>
  );
};

export default NoTransactionsView;

const styles = StyleSheet.create({
  container: {
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    marginVertical: 50,
  },
  text: {
    color: color.mediumBlacklightBlack,
  },
});
